module.exports = __webpack_public_path__ + "public/Icons/stopIcon.svg?354a0770";